import React, { useState } from 'react';
import styled from 'styled-components';
import { observer } from "mobx-react-lite";
import { useTranslation } from 'react-i18next';
import { LanguageDropdown } from './LanguageDropdown';
import { clientCollectTranslatableEntityData, translatableEntityDataArrayToCSV } from '../../helper/translationHelpers';
import { TranslationHeader } from './TranslationHeader';
import { editorStore } from '../../stores/EditorStore';
const TranslationCSVDebugOutput = styled.div.withConfig({
  displayName: "TranslationExport__TranslationCSVDebugOutput",
  componentId: "sc-35u3fb-0"
})(["white-space:pre;"]);
const csvSeparatorOptions = [";", ","];
export const TranslationExport = observer(() => {
  const {
    t
  } = useTranslation();
  const [sourceLanguage, setSourceLanguage] = useState("de");
  const [targetLanguage, setTargetLanguage] = useState("en");
  const [csvSeparator, setCsvSeparator] = useState(csvSeparatorOptions[0]);
  const complete = sourceLanguage && targetLanguage;
  const translatableEntities = complete && clientCollectTranslatableEntityData(sourceLanguage);
  const csvText = complete && translatableEntityDataArrayToCSV(translatableEntities, sourceLanguage, targetLanguage, csvSeparator);

  const exportTranslatableText = () => {
    const file = new Blob(["\uFEFF" + csvText], {
      type: 'text/csv;charset=utf-8'
    });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(file);
    const {
      sessionModule
    } = editorStore;
    const context = sessionModule ? `${sessionModule.workshopName}-${sessionModule.moduleName}` : "core-game";
    a.download = `translatableText-${sourceLanguage}-to-${targetLanguage}-${context}.csv`;
    a.click();
  };

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TranslationHeader, {
    titleKey:
    /*t*/
    "translation.export"
  }), /*#__PURE__*/React.createElement("div", null, t("translation.base_language"), ": ", /*#__PURE__*/React.createElement(LanguageDropdown, {
    value: sourceLanguage,
    setValue: setSourceLanguage
  })), /*#__PURE__*/React.createElement("div", null, t("translation.target_language"), ": ", /*#__PURE__*/React.createElement(LanguageDropdown, {
    value: targetLanguage,
    setValue: setTargetLanguage
  })), /*#__PURE__*/React.createElement("div", null, t("translation.csv_separator"), ":\xA0", /*#__PURE__*/React.createElement("select", {
    value: csvSeparator,
    onChange: e => setCsvSeparator(e.target.value)
  }, csvSeparatorOptions.map(divider => /*#__PURE__*/React.createElement("option", {
    key: divider,
    value: divider
  }, divider)))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
    onClick: exportTranslatableText
  }, t("editor.export_translatable_text"))), complete && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(TranslationCSVDebugOutput, null, csvText)));
});